/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g opacity="0.6" clip-path="url(#clip0_18300_45617)">
      <path
        d="M11.3307 11.9998C11.3307 11.1158 10.9795 10.2679 10.3544 9.64281C9.7293 9.01769 8.88145 8.6665 7.9974 8.6665C7.11334 8.6665 6.26549 9.01769 5.64037 9.64281C5.01525 10.2679 4.66406 11.1158 4.66406 11.9998"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 1.3335V6.00016"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.8125 6.81348L3.75917 7.76014"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.664062 12H1.9974"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 12H15.3333"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2422 7.76014L13.1889 6.81348"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3307 14.6665H0.664062"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33594 4.00016L8.0026 1.3335L10.6693 4.00016"
        stroke="#4F4E7B"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_18300_45617">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SunRise = (props) => <Icon component={svg} {...props} />;

export default SunRise;
